<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden">
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de monitoristas
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredMonitorsList.length}}</span>
        </h3>
        <button class="border-2 rounded border-gray-700" @click="changeFormOrder">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <div class="border-2 rounded border-gray-700 cursor-pointer p-1 ml-2">
          <download-excel :before-generate = "startDownload" :data="MonitorsList" :fields="json_fields" name="Autoridades.xls">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="black"
              width="18px"
              height="18px"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path
                d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
              />
            </svg>
          </download-excel>
        </div>
        <div
          class="rounded-full cursor-pointer bg-primary-color hover:bg-primary-color-dark p-1 ml-2"
          v-on:click="newDataModal()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current text-white h-6 w-6"
            viewBox="0 0 24 24"
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de monitoristas"
        class="w-full appearance-none border rounded py-2 px-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full flex pt-4 pb-2">
        <button
          v-on:click="statusFilterMonitors = 'all', filteredMonitorsList"
          class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterMonitors === 'all' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
        >Todos</button>
        <button
          v-on:click="statusFilterMonitors = 'active', filteredMonitorsList"
          class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterMonitors === 'active' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
        >Activos</button>
        <button
          v-on:click="statusFilterMonitors = 'inactive', filteredMonitorsList"
          class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterMonitors === 'inactive' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
        >Inactivos</button>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="currentMonitor in filteredMonitorsList"
          v-on:click="getMonitor(currentMonitor)"
          :key="currentMonitor.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{'bg-secondary-color': currentMonitor.id === monitor.id}"
        >
          <img
            :src="currentMonitor.profile_image"
            @error="loadDefaultImg"
            class="object-cover h-12 w-12 rounded-full"
            v-bind:class="[currentMonitor.inactive ? 'border-solid border-2 border-danger-color' : 'border-solid border-2 border-primary-color']"
          />
          <div class="flex flex-col ml-2">
            <span
              :class="[currentMonitor.id === monitor.id ? 'text-gray-100' : 'text-gray-900', currentMonitor.is_admin ? 'font-semibold' : 'font-normal']"
              class="group-hover:text-gray-900"
            >
              {{currentMonitor.name}} {{currentMonitor.last_name}}
              <span
                v-if="currentMonitor.is_admin"
              >*</span>
            </span>
            <span
              :class="[currentMonitor.id === monitor.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{currentMonitor.email}}</span>
            <span
              :class="[currentMonitor.id === monitor.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{currentMonitor.phone_number}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8  overflow-auto">
      <div class="w-full px-4 py-2">
        <div class="w-full flex items-center" v-if="monitor">
          <div class="w-1/3 flex items-center justify-center">
            <img
              :src="monitor.profile_image"
              class="object-cover h-40 w-40 rounded-full"
              v-bind:class="[monitor.inactive ? 'border-solid border-4 border-danger-color' : 'border-solid border-4 border-primary-color']"
            />
          </div>
          <div class="w-2/3">
            <div class="w-full flex flex-wrap items-center">
              <span class="font-bold text-gray-900 text-lg">Información Personal</span>
              <div class="flex-1 text-right">
                <button
                  v-on:click="onexport()"
                  class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
                >Descargar</button>
                <button
                  v-on:click="updateDataModal(monitor)"
                  class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
                >Editar</button>
                <button
                  @click="showingConfirm = true;"
                  class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-danger-color hover:border-transparent rounded"
                >Eliminar</button>
              </div>
              <div class="w-full">
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Nombre:</span>
                  <span class="ml-2 text-gray-700">{{monitor.name}} {{monitor.last_name}}</span>
                </div>
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Dirección:</span>
                  <span class="ml-2 text-gray-700">{{monitor.address}}</span>
                </div>
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Correo:</span>
                  <span class="ml-2 text-gray-700">{{monitor.email}}</span>
                </div>
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Teléfono:</span>
                  <span class="ml-2 text-gray-700">{{monitor.phone_number}}</span>
                </div>
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Edad:</span>
                  <span class="ml-2 text-gray-700">{{monitor.age}} años</span>
                </div>
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Sexo:</span>
                  <span class="ml-2 text-gray-700">{{monitor.sex}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <br>
        <div class="w-full mx-auto">
          <span class="font-bold text-gray-900 text-lg">Bitácora</span>
          <div class="bg-white shadow-md rounded my-6">
            <input
                type="date"
                v-model="searchByday"
                class="w-1/3 appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
              />
              <button
                class="bg-transparent hover:bg-secondary-color text-secondary-color-dark text-sm font-semibold hover:text-white py-1 px-2 mx-1 mb-3 border border-secondary-color-dark hover:border-transparent rounded"
                @click="clearSelectedDate()"
              >Limpiar</button>
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >Módulo</th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >Acción</th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >Observación</th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                      >Fecha
                      <button class="border-2 rounded border-gray-700" @click="changeFormOrderBinnacles">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 24 24">
                          <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
                          <path d="M0 0h24v24H0z" fill="none" />
                        </svg>
                      </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="type in filteredBinnacles">
                  <tr class="hover:bg-gray-200" :key="type.id">
                    <td class="py-4 px-6 border-b border-gray-300">{{type.module}}</td>
                    <td class="py-4 px-6 border-b border-gray-300">{{type.action}}</td>
                    <td v-html="type.observation" class="py-4 px-6 border-b border-gray-300" style="white-space: pre-line;"></td>
                    <td class="py-4 px-6 border-b border-gray-300">{{type.date | moment('DD/MM/YYYY hh:mm a') }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <monitor-modal
      :newMonitor="newMonitor"
      :showing="showMonitorModal"
      :viewModal="viewModal"
      @updateMonitor="updateMonitor"
      @updateAllMonitors="updateAllMonitors"
      @close="showMonitorModal = false"
    ></monitor-modal>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar este monitorista?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateActivity()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>


<script>
import MonitorModal from "./MonitorModal";
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";
import axios from "axios";
import XLSX from 'xlsx'
import moment from "moment";

export default {
  name: "MonitorsList",
  data() {
    return {
      searchByday: "",
      binnacles: [],
      json_fields: {
        Nombre: "name",
        Apellido: "last_name",
        Correo: "email",
        Edad: "age",
        Sexo: "sex",
        Telefono: "phone_number",
        Dirección: "address",
        "Url de perfil": "profile_image",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      showingConfirm: false,
      showingSuccessDelete: false,
      showMonitorModal: false,
      selectedIndex: 0,
      MonitorsList: [],
      monitor: null,
      newMonitor: false,
      viewModal: "monitor_list",
      search: "",
      statusFilterMonitors: "all",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      formOrder: "upward",
      formOrderBinnacle: "upward"
    };
  },
  components: {
    MonitorModal,
    AlertDialog
  },
  mounted() {
    this.getMonitorsList();
  },
  methods: {
    startDownload(){
      this.axios.post("apidev/api/binnacles/monitor/save/",{
          "module": "Monitoristas", 
          "action": "Descarga de información de todos los monitoristas", 
          "observation": 'Información personal de las autoridades',
          "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //// removed console log
      })
      .catch(error => {
        //// removed console log
      });
    },
    onexport () {
      const info = {
        "Nombre" : this.monitor.name,
        "Apellido": this.monitor.last_name,
        "Correo": this.monitor.email,
        "Telefono": this.monitor.phone_number,
        "Edad": this.monitor.age,
        "Sexo": this.monitor.sex
      }

      let binnacles = [];
      this.binnacles.forEach(binnacle => {
        const newBinnacle = {
          Modulo: binnacle.module,
          Acción: binnacle.action,
          Observacion: binnacle.observation,
          Fecha: moment(binnacle.date).format("DD/MM/YYYY hh:mm A"),
        };
        binnacles.push(newBinnacle);
      });

      const monitorInfo = XLSX.utils.json_to_sheet([info]) 
      const binnaclesList = XLSX.utils.json_to_sheet(binnacles);
      var wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, monitorInfo, 'Monitorista')
      XLSX.utils.book_append_sheet(wb, binnaclesList, 'Bitacora')

      XLSX.writeFile(wb, 'Monitorista.xlsx')

      this.axios.post("apidev/api/binnacles/monitor/save/",{
          "module": "Monitoristas", 
          "action": "Descarga de información de un monitorista", 
          "observation": `${this.monitor.name} ${this.monitor.last_name}`,
          "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //// removed console log
      })
      .catch(error => {
        //// removed console log
      });
    },
    getMonitorsList: function() {
      axios
        .get("apidev/monitors", this.config)
        .then(response => {
          this.MonitorsList = response.data;
          this.MonitorsList.forEach(data => {
            if (data.profile_image != null) {
              data.profile_image = "apidev/" + data.profile_image;
            } else {
              data.profile_image =
                "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
            }
          });

          if (this.MonitorsList.length > 0) {
            this.monitor = this.MonitorsList[0];
            this.fetchAllBinnacles(this.monitor.email)
          }
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getMonitor: function(monitor) {
      this.monitor = monitor;
      this.fetchAllBinnacles(this.monitor.email)
    },
    fetchAllBinnacles(email) {
      this.axios
        .post(
          "apidev/api/binnacles/monitor/list",
          {
            "email": email
          },
          this.config
        )
        .then(response => {
          this.binnacles = response.data.binnacles;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    updateDataModal: function(monitor) {
      this.showMonitorModal = true;
      this.newMonitor = false;
      EventBus.$emit("editModal", monitor);
    },

    newDataModal: function() {
      this.showMonitorModal = true;
      this.newMonitor = true;
    },

    updateMonitor: function(Monitor) {
      this.MonitorsList.forEach(monitor => {
        if (monitor.id == Monitor.id) {
          let updateMonitor = Object.assign({}, Monitor);
          monitor.name = updateMonitor.name;
          monitor.last_name = updateMonitor.last_name;
          monitor.address = updateMonitor.address;
          monitor.phone_number = updateMonitor.phone_number;
          monitor.age = updateMonitor.age;
          monitor.sex = updateMonitor.sex;
          monitor.is_admin = updateMonitor.is_admin;
          monitor.profile_image = updateMonitor.profile_image;
        }
      });
    },
    updateAllMonitors: function() {
      this.getMonitorsList();
    },

    updateActivity: function() {
      this.axios
        .delete("apidev/monitors/" + this.monitor.id, this.config)
        .then(response => {
          return this.axios.post("apidev/api/binnacles/monitor/save/",{
              "module": "Monitoristas", 
              "action": "Eliminación de un monitorista", 
              "observation": `${this.monitor.name} ${this.monitor.last_name}`,
              "email": localStorage.getItem("email")
            },
            this.config
          )
        })
        .then(response => {
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
          this.getMonitorsList();
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    loadDefaultImg(event) {
      event.target.src =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    changeFormOrderBinnacles() {
      if (this.formOrderBinnacle === "upward") {
        this.formOrderBinnacle = "downward";
      } else {
        this.formOrderBinnacle = "upward";
      }
    },
    clearSelectedDate() {
      this.searchByday = "";
    }
  },
  computed: {
    filteredMonitorsList: function() {
      return this.MonitorsList.filter(monitor => {
        let full_name = monitor.name + " " + monitor.last_name;
        switch (this.statusFilterMonitors) {
          case "all":
            return (
              full_name.toLowerCase().includes(this.search.toLowerCase()) ||
              monitor.phone_number
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              monitor.email.toLowerCase().includes(this.search.toLowerCase())
            );
          case "active":
            return (
              (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                monitor.phone_number
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                monitor.email
                  .toLowerCase()
                  .includes(this.search.toLowerCase())) &&
              !monitor.inactive
            );
          case "inactive":
            return (
              (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                monitor.phone_number
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                monitor.email
                  .toLowerCase()
                  .includes(this.search.toLowerCase())) &&
              monitor.inactive
            );
          default:
            break;
        }
      }).sort((a, b) => {
        if (this.formOrder === "upward") {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          return 0;
        } else {
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return -1;
          }
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return 1;
          }
          return 0;
        }
      });
    },
    filteredBinnacles() {
      return this.binnacles.filter(binnacle => {
        let date = moment(binnacle.date).format("YYYY-MM-DD");
        return date.toLowerCase().includes(this.searchByday.toLowerCase());
      }).sort((a, b) => {
        if (this.formOrderBinnacle === "upward") {
          return new Date(a.date) - new Date(b.date);
        } else {
          return new Date(b.date) - new Date(a.date);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
